import React, { Component } from "react";
import { Button, Container, Grid, Icon } from "semantic-ui-react";
import Sidebar from "../../components/shared/sidebar";
import HeaderInfo from "../../components/shared/header";
import Footer from "../../components/shared/footer";
import {
  FeaturedArticle,
  FeaturedStories,
  LatestArticles,
} from "../../components/shared/article-helper-components";
import "./articles.css";

class Articles extends Component {
  state = { menuOpen: false };

  handleMenuToggle = () =>
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }));

  handleStateChange = (state) => this.setState({ menuOpen: state.isOpen });

  render() {
    return (
      <div id="App">
        <Sidebar
          pageWrapId="article-content"
          outerContainerId="App"
          isOpen={this.state.menuOpen}
          onStateChange={this.handleStateChange}
          active={"articles"}
        />
        <main id="article-content">
          <Container>
            <div className="header-content">
              <HeaderInfo />
              <Button basic icon size="big" onClick={this.handleMenuToggle}>
                <Icon name="bars" />
              </Button>
            </div>
            <div className="featured">
              <Grid>
                <Grid.Row columns={2} only="computer">
                  <Grid.Column computer={11} mobile={16} tablet={16}>
                    <FeaturedArticle />
                    <LatestArticles />
                  </Grid.Column>
                  <Grid.Column computer={5} mobile={16} tablet={16}>
                    <FeaturedStories />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2} only="tablet mobile">
                  <Grid.Column computer={11} mobile={16} tablet={16}>
                    <FeaturedStories />
                  </Grid.Column>
                  <Grid.Column computer={5} mobile={16} tablet={16}>
                    <FeaturedArticle />
                    <LatestArticles />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            <Footer />
          </Container>
        </main>
      </div>
    );
  }
}

export default Articles;
